var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircularFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106.374,
    height: 96.87,
    viewBox: "0 0 106.374 96.87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-1065.712 -678.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M39.456,0A39.456,39.456,0,1,0,78.913,39.456,39.61,39.61,0,0,0,39.456,0Z",
    transform: "translate(1067.212 679.544)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M28.8,0A28.8,28.8,0,1,0,57.6,28.8,28.913,28.913,0,0,0,28.8,0Z",
    transform: "translate(1077.868 690.2)",
    fill: "#8cbd8b",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 36.617,
    height: 36.617,
    rx: 4,
    transform: "translate(1135.469 738.296)",
    fill: "#d5bc4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "recycle",
    transform: "translate(1143.955 746.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M9.761,1.064a8.708,8.708,0,0,1,4.471,1.267,9.679,9.679,0,0,1,2.332,1.963l-2.308-.076a.491.491,0,1,0-.032.982l3.193.105a.491.491,0,0,0,.641-.642l-.105-3.192a.491.491,0,0,0-.982.022s0,.007,0,.011l.061,1.842a10.713,10.713,0,0,0-2.294-1.857A9.692,9.692,0,0,0,9.761.082,9.5,9.5,0,0,0,2.622,3.275,10.139,10.139,0,0,0,0,9.843a.491.491,0,0,0,.982,0,9.131,9.131,0,0,1,2.369-5.91A8.528,8.528,0,0,1,9.761,1.064Zm0,0",
    transform: "translate(0 -0.082)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.041,236.012a.491.491,0,0,0-.491.491,9.132,9.132,0,0,1-2.369,5.911,8.528,8.528,0,0,1-6.409,2.868,8.707,8.707,0,0,1-4.471-1.267,9.687,9.687,0,0,1-2.332-1.963l2.308.076a.491.491,0,0,0,.032-.982l-3.193-.105a.491.491,0,0,0-.641.642l.105,3.192a.491.491,0,1,0,.982-.022s0-.007,0-.011L40.5,243a10.719,10.719,0,0,0,2.294,1.857,9.691,9.691,0,0,0,4.976,1.407,9.5,9.5,0,0,0,7.139-3.193,10.139,10.139,0,0,0,2.622-6.568A.491.491,0,0,0,57.041,236.012Zm0,0",
    transform: "translate(-37.888 -226.742)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircularFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circular_fill.08dbe140.svg";
export { ForwardRef as ReactComponent };